// host
const { VUE_APP_BASE_URL } = process.env;
export let BASE_URL =
  process.env.NODE_ENV === "production"
    ? window.location.host
    : VUE_APP_BASE_URL;
// export let BASE_URL = process.env.NODE_ENV === "production" ? window.location.host : "192.168.124.100:18443"
export let networkType = window.location.protocol;
export const WS_TYPE = window.location.protocol === "https:" ? "wss" : "ws";
